import { useState, useEffect } from "react";
import "./css/Modal.css";
import { FaTimesCircle, FaWindowClose } from "react-icons/fa";
import {API_BASE_URL, CommonAreasUpdateAPIEndpoint} from "../constant.js"

const EditAreaModal = ({ open, onClose, area, onUpdate }) => {
  const token = sessionStorage.getItem("JWTtoken");
  const [form, setForm] = useState({
    name: "",
    description: "",
    capacity: "",
    charge: "",
    status: "active"
  });

  useEffect(() => {
    if (area) {
      setForm(area); // pre-fill form
    }
  }, [area]);

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

   const validate = () => {

     if (!form.name.trim() || !form.commonareadesc.trim() || !form.charge.trim() || !form.capacity.trim()) {
      alert("Name, Description, Charge and Capacity are required!");
      return; // Stop submission  
    }

    if (Number(form.charge) <= 0 || Number(form.capacity) <= 0) {
      alert("Charge and Capacity must be greater than zero!");
      return; // Stop submission  
    }

    return true;

   }

  const handleSubmit = async(e) => {
    e.preventDefault();
    onUpdate(form); // send updated data

    if (!validate()) return;

    try {
        const updateApiURL = API_BASE_URL + CommonAreasUpdateAPIEndpoint;
        const payload = {
          ...form  //existing form fields
        };
    const response = await fetch(updateApiURL,
      {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
         },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();
    if (result.status) {
      alert("Common-area updated successfully");
    } else {
      alert(result.message);
    }
  } catch (err) {
    alert("Server error");
  }
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Edit {form.name} <div style={{ float : "right" }} > <FaWindowClose className="edit-icon"  onClick={onClose} /> </div>  </h3>

        <form onSubmit={handleSubmit}>
        Title
          <input
            name="name"
            placeholder="Area Name"
            value={form.name}
            onChange={handleChange}
            required
          />
            Description
          <textarea 
            name="commonareadesc"
            placeholder="Description"
            value={form.commonareadesc}
            onChange={handleChange}
          />
Capacity
          <input
            name="capacity"
            type="number"
            placeholder="Capacity"
            value={form.capacity}
            onChange={handleChange}
            required
          />
Charge
          <input
            name="charge"
            type="number"
            placeholder="Charge"
            value={form.charge}
            onChange={handleChange}
          />
Status
          <select name="status" value={form.status} onChange={handleChange}>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>

          <div className="modal-actions">
            <button type="submit" className="btn-save" >
              Save
            </button>
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAreaModal;
